import React from 'react';
import { Stack, Text, Flex, StackProps, VStack, FlexProps, Box, BoxProps } from '@chakra-ui/react';
import { ConditionalWrapper } from '../Wrappers/ConditionalWrapper';

interface ITitleDescription {
  title?: string;
  description?: string;
  isDisabled?: boolean;
}

const TitleDescription = ({ title, description, isDisabled, ...props }: ITitleDescription) => {
  if (!(title || description)) return null;

  return (
    <Flex flexDir="column" {...props}>
      {title && (
        <Box as="h2" textStyle="h3" opacity={isDisabled ? 0.6 : 'initial'}>
          {title}
        </Box>
      )}
      {description && (
        <Text textStyle="label" opacity={isDisabled ? 0.6 : 'initial'}>
          {description}
        </Text>
      )}
    </Flex>
  );
};

interface IContentCard extends StackProps {
  title?: string;
  rightTitleAdornment?: any;
  isDisabled?: boolean;
  description?: string;
  innerStackProps?: StackProps;
  headerContainerFlexProps?: FlexProps;
  titleDescriptionFlexProps?: FlexProps;
  wrapperContainerBoxProps?: BoxProps;
}

export const ContentCard = (props: IContentCard) => {
  const {
    children,
    title,
    rightTitleAdornment,
    isDisabled,
    description,
    innerStackProps,
    headerContainerFlexProps = {},
    titleDescriptionFlexProps = {},
    wrapperContainerBoxProps = {},
    ...rest
  } = props;
  const showTitle = !!(title || description || rightTitleAdornment);

  if (!showTitle && isDisabled) return null;

  return (
    <ConditionalWrapper
      condition
      wrapper={(kids) => (
        <Box w="100%" {...wrapperContainerBoxProps}>
          {kids}
        </Box>
      )}
    >
      <VStack
        p={{ base: 4, sm: 6 }}
        bg="white"
        boxShadow={{ base: 'sm', sm: 'md' }}
        borderRadius={{ base: 0, sm: 4 }}
        spacing={4}
        alignItems="flex-start"
        justifyContent="flex-start"
        direction="column"
        {...rest}
      >
        {showTitle && (
          <Flex
            align={{ base: 'start', md: 'center' }}
            justify="space-between"
            w="100%"
            flexDir="row"
            h={8}
            {...headerContainerFlexProps}
          >
            <TitleDescription
              title={title}
              description={description}
              isDisabled={isDisabled}
              mb={{ base: rightTitleAdornment ? 4 : 0, md: 0 }}
              {...titleDescriptionFlexProps}
            />
            {rightTitleAdornment}
          </Flex>
        )}
        {!isDisabled && (
          <Stack w="100%" {...innerStackProps}>
            {children}
          </Stack>
        )}
      </VStack>
    </ConditionalWrapper>
  );
};
